export const ingredientInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Flour",
  },
  {
    id: "manufacturerCode",
    label: "Manufacturer Code",
    type: "text",
    placeholder: "Manufacturer Code",
  },
  {
    id: "volume",
    label: "Volume Ingredient",
    type: "checkbox",
  },
  {
    id: "reportInProd",
    label: "Report Consumption in Production",
    type: "checkbox",
    placeholder: "1.04",
  },
];

export const ingredientVolumeInputs = [
  {
    id: "hydration",
    label: "Hydration (%)",
    type: "number",
    placeholder: "80%",
  },
  {
    id: "massconversion",
    label: "Volume Density (g/mL)",
    type: "number",
    placeholder: "1.04",
  },
];

export const doughInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "French",
  },
  {
    id: "manufacturerCode",
    label: "Manufacturer Code",
    type: "text",
    placeholder: "Manufacturer Code",
  },
  // {
  //   id: "minMix",
  //   label: "Min Mix",
  //   type: "number",
  //   placeholder: "Minimum Weight for Mix",
  //   unitOptions: true,
  // },
  // {
  //   id: "maxMix",
  //   label: "Max Mix",
  //   type: "number",
  //   placeholder: "Minimum Weight for Mix",
  //   unitOptions: true,
  // },
  {
    id: "mixTime",
    label: "Mix Time",
    type: "number",
    placeholder: "Time of mix (minutes)",
  },
  {
    id: "mixTime2",
    label: "Second Mix Time",
    type: "number",
    placeholder: "Time of mix (minutes)",
  },
  {
    id: "fermentTime",
    label: "Fermentation Time",
    type: "number",
    placeholder: "Time of fermentation (minutes)",
  },
  {
    id: "reworkMixTime",
    label: "Rework Mix Time",
    type: "number",
    placeholder: "Time of mix (minutes)",
  },
  {
    id: "reworkMixTime2",
    label: "Rework Second Mix Time",
    type: "number",
    placeholder: "Time of mix (minutes)",
  },
  {
    id: "reworkFermentTime",
    label: "Rework Fermentation Time",
    type: "number",
    placeholder: "Time of fermentation (minutes)",
  },
];

export const productInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Hero",
  },
  {
    id: "manufacturerCode",
    label: "Manufacturer Code",
    type: "text",
    placeholder: "Manufacturer Code",
  },
  {
    id: "description",
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: "piecePerBoard",
    label: "Piece/Board",
    type: "number",
    placeholder: "Piece/Board",
  },
  {
    id: "boardPerRack",
    label: "Board/Rack",
    type: "number",
    placeholder: "Piece/Board",
  },
  // {
  //   id: "price",
  //   label: "Price",
  //   type: "number",
  //   placeholder: "1.00",
  // },
];

export const lineInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Fancy Line Name",
  },
];

export const ovenInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Oven Name",
  },
  {
    id: "capacity",
    label: "Default Capacity (pieces/batch)",
    type: "number",
    placeholder: "60",
  },
  {
    id: "bakeTimeMinutes",
    label: "Default Bake Time (minutes)",
    type: "number",
    placeholder: "30",
  },
  {
    id: "preheatMinutes",
    label: "Preheat Time (minutes)",
    type: "number",
    placeholder: "10",
  },
  {
    id: "cooldownMinutes",
    label: "Cooldown Time (minutes)",
    type: "number",
    placeholder: "5",
  },
  {
    id: "throughputPerHour",
    label: "Fallback Throughput (pieces/hour)",
    type: "number",
    placeholder: "120",
  },
];

export const productionListInputs = [
  {
    id: "name",
    label: "Name",
    type: "text",
    placeholder: "Morning Production",
  },
];

export const userInputs = [
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "john_doe",
  },
  {
    id: "displayName",
    label: "Name and surname",
    type: "text",
    placeholder: "John Doe",
  },
  {
    id: "email",
    label: "Email",
    type: "mail",
    placeholder: "john_doe@gmail.com",
  },
  {
    id: "phone",
    label: "Phone",
    type: "text",
    placeholder: "+1 234 567 89",
  },
  {
    id: "password",
    label: "Password",
    type: "password",
  },
  {
    id: "address",
    label: "Address",
    type: "text",
    placeholder: "Elton St. 216 NewYork",
  },
  {
    id: "country",
    label: "Country",
    type: "text",
    placeholder: "USA",
  },
];
